module.exports = __webpack_public_path__ + "media/images/arrows/long-white-236d5284cc59079fd108b74213e5ef11.svg";